/*
 *
 * FaQs constants
 *
 */

export const DEFAULT_ACTION = '/FaQs/DEFAULT_ACTION';


export const FAQ_LIST = [
  {
    header: 'FAQs for Zaggle Propel Card',
    title: 'Q. How do I use my Zaggle Propel Card to place an order ?',
    description: '<p>A. Please register on www.zaggle.in or the mobile app. Add your Zaggle Propel Card and redeem against vouchers. eVouchers will be sent by email and physical vouchers by courier.</p>',
  },
  {
    title: 'Q. What is the estimated delivery time ?',
    description: '<p>A. The Gift Vouchers will be dispatched within 8 working days of receiving the order. eVouchers within 3 working days if not in stock.</p>',
  },
  {
    title: 'Q. What is the validity of the Gift Voucher ?',
    description: '<p>A. Typically a Gift Voucher is Valid for a period of 3 to 12 months.<br />However, the validity differs from Brand to Brand as per the Brand&apos;s terms and conditions.<br />We request you to kindly go through the redemption terms tab in each Gift voucher page.</p>',
  },
  {
    title: 'Q. In which cities can I use a given Brands gift voucher ?',
    description: '<p>A. For physical vouchers, you will need to visit that Brand&apos;s store. The cities where the Brand&apos;s stores are located can be determined either by using the store locater in the gift voucher page or by checking on given Brand&apos;s website.</p>',
  },
  {
    title: 'Q. Do you deliver to locations outside India ?',
    description: '<p>A. Currently this service is provided only in India.</p>',
  },
  {
    title: 'Q. What Payment Options do I have ?',
    description: '<p>A. We accept payments made through Credit card/Debit Cards/Cash Cards and Net Banking.</p>',
  },
  {
    header: 'General FAQs for Zaggle Network Cards',
    title: 'Q. What are these cards ?',
    description: '<p>A. These cards are preloaded cards that can be swiped at the participating merchants mentioned on the reverse of the cards.</p>',
  },
  {
    title: 'Q.  Where can these cards be used?',
    description: '<ol><li>Wave card can be used at : Lifestyle, Inox, Croma, Domino’s, CCD, Velvetcase.com, @home.</li><li>Kohinoor at all Jewellery merchants in India accepting Visa cards. </li><li>Kuber cards can be used at all VISA outlets in India.</li><li>Zeon card can be used at : Reliance Digital, Pantaloons, Hypercity, Bata, Hush Puppies, Prestige, Urban Ladder, Cleartrip, Hamleys, Imagica.</li></ol><p>All these cards can be used at the participating stores as well as on their online e-commerce platforms.</p>',
  },
  {
    title: 'Q. Can I make online transactions ?',
    description: '<p>A. You can make online transactions at the participating merchants, using the IPIN given along with the card in the welcome kit for VBV verification.</p>',
  },
  {
    title: 'Q. How can I check my card balance ?',
    description: '<ol><li>You can check your card balance in the Zaggle App or logging in on <a href="/payments">www.zaggle.in/payments</a>.</li><li>You can also call our toll free number 1860 500 1231, between 10.00 AM to 7.00 PM Monday to Saturday.</li></ol>',
  },
  {
    header: 'FAQs for ZAKEY',
    title: 'Q. What is ZAKEY?',
    description: "<p>Zaggle Zakey is the perfect wearable for those who want to make quick and convenient payments.<br /> Zakey is linked to Yes Bank and all payments are approved by the Rupay network, so you can rest assured that your payments are safe and secure.<br />Zakey is a new-age stylish wearable that will change your payment journey! Just use Zakey to transact at any contactless enabled POS device.<br /> Hold the Zakey in front of the POS device during payment & voila! It's the perfect gift: Fast. Effortless. Secure</p>",
  },
  {
    title: 'Q. Where can ZAKEY be used?',
    description: '<p>It can be used across all merchants with wifi enabled pos machine with TAP facility.</p>',
  },
  {
    title: 'Q. For how much amount can the ZAKEY be used for at the Merchant Store?',
    description: '<p>The ZAKEY can be used for any amount up to the amount loaded on the card. The card can be used only until the card expires.</p>',
  },
  {
    title: 'Q. How can I check the balance on my ZAKEY?',
    description: '<p>You can check the balance of the card on Zaggle mobile App under WEARABLES section</p>',
  },
  {
    title: 'Q. What happens if ZAKEY gets lost ?',
    description: '<p>A. If Zakey is lost, please block your Zakey under Card Settings and raise a replacement request on the Zaggle Mobile app. <br/> Replacement charges will be applicable.</p>',
  },
  {
    title: 'Q. What is the fee for re-issuing card ?',
    description: '<p>The Fee for re-issuing is Rs.499+ GST</p>',
  },
  {
    title: 'Q. Can the ZAKEY be loaded again ?',
    description: '<p>Yes, it is a reloadable card and can be topped up as per your KYC status</p>',
  },
  {
    title: 'Q. Can the user disable or enable the POS & online transactions?',
    description: '<p>Yes, a user can enable and disable both using ZAGGLE app at given point of time.</p>',
  },
  {
    title: 'Q. How do I activate my ZAKEY?',
    description: '<p>Below are the steps: <br/> 1. Download ZAGGLE APP <br/> 2. Login or signup <br/> 3. Complete KYC and create MPIN <br/> 4. Activate the wearable with one click.</p>',
  },
  {
    title: 'Q. Does these wearable need charging?',
    description: '<p>No it doesn’t need charging.</p>',
  },
  {
    title: 'Q. Can the POS pin be set or changed?',
    description: '<p>Yes, both can be done via ZAGGLE app.</p>',
  },
  {
    title: 'Q. Possible situation where ZAKEY can be declined.',
    description: '<p>Network could be down, in which case you need to try again later <br/> 1. The Wearable is yet to be activated <br/> 2. The amount being tapped is greater than the available balance on the card. <br/> In case of any such issues, please contact the Customer Care toll free number 1860 500 1231, between 10:00 AM to 7:00 PM, Monday to Saturday. You can also write an email to care@zaggle.in. The team will get the issue resolved at the earliest.</p>',
  },
  {
    title: 'Q. Can the ZAKEY be loaded again?',
    description: '<p>Yes, it is a reloadable card and can be topped up based on your KYC status.</p>',
  },
  {
    title: 'Q. What is the limits of ZAKEY transaction at Merchant Store? ',
    description: '<p>1.) You can use Zakey for Tap-n-pay upto maximum of Rs.5,000 without any PIN. <br/> 2.) For transactions above Rs.5,000 you need to provide POS PIN along with tapping. </p>',
  },
  {
    header: 'FAQs for Indusind Kuber Cards',
    title: 'Q. What is the Indusind Kuber Card ?',
    description: '<p>The Indusind Kuber Card is a prepaid Gift Card that can be used at any VISA/Rupay merchants in India. This card will come preloaded with the amount gifted to you. </p>',
  },
  {
    title: 'Q. How is the Indusind Kuber Card used ?',
    description: '<p>A. The Indusind Kuber Card being a swipe card just like any other debit/credit card can be used at the point of sale at the merchant store by simply swiping it. The Indusind Kuber Card can also be used online.</p>',
  },
  {
    title: 'Q. For how much amount can the Indusind Kuber Card be swiped for at the Merchant Store ?',
    description: '<p>A. The Indusind Kuber Card can be used for any amount up to the amount loaded on the card. The card can be used only until the validity period.</p>',
  },
  {
    title: 'Q. How to I check when the card will expiry ?',
    description: '<p>A. The card expiry date is printed on the front of the card.</p>',
  },
  {
    title: 'Q. Can we use this card online ?',
    description: '<p>A. The Indusind Kuber card can be used for making online purchases.</p>',
  },
  {
    title: 'Q. How can I check the balance on my card ?',
    description: '<p>You can check your card balance in the Zaggle App or logging in on <a href="/payments">www.app.zaggle.in/payments/></p>.',
  },
  {
    title: 'Q. How do I place an order online ?',
    description: '<p>A. Once you have selected your item, in the payment section select the VISA debit card option and enter the <br />1. Card number <br />2. Expiry date<br />3. CVV number <br />Next, enter the Internet Personal Identification Number (IPIN) for the second factor authentication.</p>',
  },
  {
    title: 'Q. What happens if the card gets lost ?',
    description: '<p>If Indusind Kuber Card is lost, please block your Indusind Kuber Card  under Card Settings and raise a replacement request on the Zaggle Mobile app and Zaggle.in</p>',
  },
  {
    title: 'Q. What is the fee for re-issuing card ?',
    description: '<p>A. The fees for reissuance is Rs. 100/- plus GST applicable.</p>',
  },
  {
    title: 'Q. Can value be added to the Indusind  Kuber Card ?',
    description: '<p>No. Once the amount on the Card has been used, the Card is no longer valid. Indusind Kuber cards are non reloadable prepaid cards.</p>',
  },
  {
    title: 'Q. Can the Card be used if its Available Balance does not cover the total purchase price ?',
    description: '<p>A. The Card cannot be used to make transactions that exceed the available balance. For such a transaction you need to pay the difference by another method if the merchant agrees.</p>',
  },
  {
    title: 'Q. Possible situation where card can be declined.',
    description: '<p>Network could be down, in which case you need to try again later <br/> 1. The card is yet to be activated. <br/> 2. The amount being swiped is greater than the available balance on the card. <br/> 3. The card is being used at wallets like PAYTM, MOBIQWIK etc. As per RBI guidelines these cards cannot be used on wallets. <br/> In case of any such issues, please contact the Customer Care toll free number 1860 500 1231, between 10:00 AM to 7:00 PM, Monday to Saturday. You can also write an email to care@zaggle.in. The team will get the issue resolved at the earliest.</p>',
  },
  {
    title: 'Q. How to activate the IndusInd Kuber Card?',
    description: '<p>To activate or link your Zaggle IndusInd Kuber Card, follow these steps:<br/> 1. Go to the home page of the Zaggle Mobile App.<br/> 2. Tap on "Zaggle Cards" at the bottom of the page.<br/> 3. Select "Activate/Link your Zaggle Card".<br/> 4. Enter your Card Number.<br/> 5. Click on "Proceed" and enter the OTP sent to your registered mobile number. Then, click on "Confirm".<br/> 6. Your card will be successfully added/linked to your account.</p>',
  },
  {
    title: 'Q. How to set POS PIN?',
    description: "<p>To Set the POS PIN, follow these steps:<br/> 1. Go to the home page of the Zaggle Mobile App.<br/> 2. Tap on \"Zaggle Cards\" at the bottom of the page.<br/> 3. Select the Zaggle IndusInd Kuber Card.<br/> 4. Tap on the settings icon located at the top right corner.<br/> 5. Choose the 'Set POS PIN' option.<br/> 6. Enter the new POS PIN.<br/> 7. Provide the OTP.<br/> 8. Click on 'Confirm'.<br/> 9. Your POS PIN will be successfully updated.</p>",
  },
  {
    title: 'Q. How to set IPIN?',
    description: "<p>To Set the IPIN, follow these steps:<br/> 1. Go to the home page of the Zaggle Mobile App.<br/> 2. Tap on \"Zaggle Cards\" at the bottom of the page.<br/> 3. Select the Zaggle IndusInd Kuber Card.<br/> 4. Tap on the settings icon located at the top right corner.<br/> 5. Choose the 'Set IPIN' option.<br/> 6. Enter the new IPIN.<br/> 7. Provide the OTP.<br/> 8. Click on 'Confirm'.<br/> 9. Your IPIN will be successfully updated.</p>",
  },
  {
    header: 'FAQs for INDUSIND BANK Zinger Card',
    title: 'Q. What is the INDUSIND BANK Zinger Card?',
    description: '<p>The INDUSIND BANK Zinger card is a Multiwallet Card with intelligence to utilize the funds on specific set of merchant categories codes (MCC). It has multiple wallets like Meal, Fuel, Travel, Expense, Telecom/Broadband and Reward. These wallets can be topped up as required.</p>' },
  {
    title: 'Q. Where can I use the Meal Wallet?',
    description: '<p>Meal cards can be used at restaurants, food outlets, and grocery stores.</p>',
  },
  {
    title: 'Q. Where can I use the Fuel Wallet?',
    description: '<p>Fuel wallet can be used at petrol bunks and fuel stations.</p>',
  },
  {
    title: 'Q. Where can I use the Car Maintenance Wallet?',
    description: '<p>Carmaintenance wallet can be used for vehicle repairs, car washes, and car rentals.</p>',
  },
  {
    title: 'Q. Where can I use the Wellness Wallet?',
    description: '<p>Wellness wallet can be used at healthcare, hospitals and fitness activities.</p>',
  },
  {
    title: 'Q. Where can I use the Gadget Wallet?',
    description: '<p>A gadget wallet can be used for electronic devices and gadgets.</p>',
  },
  {
    title: 'Q. Where can I use the Attire Wallet?',
    description: '<p>Attire wallet can be used at apparel stores and family clothing store.</p>',
  },
  {
    title: 'Q. Where can I use the Travel Wallet?',
    description: '<p>Travel wallet can be used at travel agencies, tour operator and railway blue line.</p>',
  },
  {
    title: 'Q. How to use my card for transactions?',
    description: '<p>Offline/POS transaction: Set your POS PIN in the Zaggle app under "INDUSIND BANK multiwallet physical card" settings and you can start using it.<br/> Online/ECOM transaction: Enable ECOM in the Zaggle app under "INDUSIND BANK multiwallet physical card" settings and start using it on Ecom platforms.</p>',
  },
  {
    title: 'Q. For how much amount can the INDUSIND BANK Zinger Card be swiped for at the Merchant Store?',
    description: '<p>The INDUSIND BANK Zinger card can be used for any amount up to the amount loaded on the card. The card can be used only until the card expires.</p>',
  },
  {
    title: 'Q. How to check when the card will expire?',
    description: '<p>The expiry date will be printed on the front of the card. It will be visible in the Zaggle Mobile App as well.</p>',
  },
  {
    title: 'Q. Can we use this card online?',
    description: '<p>Yes, the Zinger card can be used online in their corresponding category merchants.</p>',
  },
  {
    title: 'Q. How can I check the balance on my card?',
    description: '<p>You can check the balance of the card on Zaggle mobile App under INDUSIND BANK Multiwallet cards section.</p>',
  },
  {
    title: 'Q. What happens if the card gets lost?',
    description: '<p>If your card is lost, you can lock/block the card from Zaggle mobile APP and report it to Zaggle customer care at toll free number 1860 500 1231, between 10:00 AM to 7:00 PM, Monday to Saturday. You can also write an email to care@zaggle.in care for a replacement. Replacement charges will be applicable.</p>',
  },
  {
    title: 'Q. What is the fee for re-issuing the card?',
    description: '<p>The Fee for re-issuing is Rs.200 + GST = Rs.236</p>',
  },
  {
    title: 'Q. Can the Zinger Card be loaded again?',
    description: '<p>Yes, it is a reloadable card and can be topped up as per your KYC status</p>',
  },
  {
    title: 'Q. How to complete my Min KYC?',
    description: '<p>Log in with your corporate mobile number, complete the "Card account creation" with OTP, then fill in and submit the KYC details. MinKYC is successfully completed.</p>',
  },
  {
    title: 'Q. How to view the INDUSIND BANK Card?',
    description: '<p>You can view the card, provided the min KYC is completed. Go to “Zaggle Cards” tab present on the bottom of the Zaggle mobile app, click on “INDUSIND BANK multiwallet card”, card will be displayed along with the card balance and the transaction details. Please note that you need to create MPIN and complete the security questions while viewing the card, if not completed before.</p>',
  },
  {
    title: 'Q. Possible situation where card can be declined?',
    description: '<p>Network could be down; in which case you need to try again later. The card is yet to be activated. The amount being swiped is greater than the available balance on the card. In case of any such issues, please contact the Customer Care toll free number 1860 500 1231, between 10:00 AM to 7:00 PM, Monday to Saturday. You can also write an email to care@zaggle.in. The team will get the issue resolved at the earliest.</p>',
  },
  {
    title: 'Q. How to activate my INDUSIND BANK Zinger card?',
    description: '<p>There is no separate process for activating the INDUSIND BANK Zinger card. Cards get activated once the KYC is completed.</p>',
  },
  {
    title: 'Q. How to view URN number?',
    description: '<p>To find your URN number, open the Zaggle App, click on Zaggle Cards, and look below the card number details.</p>',
  },
  {
    title: 'Q. How to replace my Card in case I have lost the old card or the card has expired?',
    description: "<p>Incase the card get's lost, permanently block your card or the card has expired, go to \"Zaggle Cards,\" select your card, and choose \"Card Settings,\" then \"Block Card.\" Email care@zaggle.in with your URN and dispatch address; a replacement card will be sent, with applicable charges deducted.</p>",
  },
  {
    title: 'Q. How do I book an appointment for Full KYC?',
    description: '<p>Schedule your Biometric KYC Appointment via Zaggle Mobile App: 1. Log in 2. Access "Zaggle cards" 3. Proceed 4. Book appointment 5. Complete form 6. Submit.</p>',
  },
  {
    header: 'FAQs For Yes Bank Zinger card',
    title: 'Q. What is the Yes bank Zinger Card ?',
    description: '<p>The YES bank Zinger card is a Multiwallet Card with intelligence to utilize the funds on specific set of merchant categories codes (MCC). It has multiple wallets like Meal, Fuel, Travel, Expense, Telecom/Broadband and Reward. These wallets can be topped up as required</p>',
  },
  {
    title: 'Q. How is the YES Bank Zinger card Used?',
    description: '<p>Each wallet of the Zinger card can be used only at its corresponding category merchants (both at store and online). For instance, the Meal wallet can be used only at food merchants, the Fuel wallet only at fuel stations/petrol pumps across India, and the Expense wallet can be used at all outlets. Cash can even be withdrawn from an ATM with this wallet.</p>',
  },
  {
    title: 'Q. How to use my card for transaction?',
    description: '<p>Offline/POS transaction: You need to Set POS pin to swipe the card in any offline shops. Go to “Zaggle Cards” tab present on the bottom of the Zaggle mobile app, click on “Yes Bank multiwallet physical card”, click on Setting icon on the top right corner, select “Set POS pin” option available on the dropdown, enter the 4-digit pin and the expiry date of the card, POS pin is successfully set, you can use the POS pin for transactions and ATM withdrawal. Online/ECOM transaction: You need to enable ecom transaction to use the card for online transactions. Go to “Zaggle Cards” tab present on the bottom of the Zaggle mobile app, click on “Yes Bank multiwallet physical card”, click on Setting icon on the top right corner, select “Enable ECOM” option available on the dropdown, provide a confirmation to enable ECOM by clicking on Yes Button.</p>',
  },
  {
    title: 'Q. For how much amount can the YES Bank Zinger Card be swiped for at the Merchant Store?',
    description: '<p>The YES Bank Zinger card can be used for any amount up to the amount loaded on the card. The card can be used only until the card expires.</p>',
  },
  {
    title: 'Q. How to check when the card will expire?',
    description: '<p>The expiry date will be printed on the front of the card. It will be visible in the Zaggle Mobile App as well.</p>',
  },
  {
    title: 'Q. Can we use this card online?',
    description: '<p>Yes, the Zinger card can be used online in their corresponding category merchants.</p>',
  },
  {
    title: 'Q. How can I check the balance on my card?',
    description: '<p>You can check the balance of the card on Zaggle mobile App under Yes bank Multiwallet cards section.</p>',
  },
  {
    title: 'Q. What happens if the card gets lost?',
    description: '<p>If Yes Bank Zinger Card is lost, please block your Yes Bank Zinger Card under Card Settings and raise a replacement request on the Zaggle Mobile app and Zaggle.in; Replacement charges will be applicable.</p>',
  },
  {
    title: 'Q. What is the fee for re-issuing card?',
    description: '<p>The Fee for re-issuing is Rs.200 + GST.</p>',
  },
  {
    title: 'Q. Can the Zinger Card be loaded again?',
    description: '<p>Yes, it is a reloadable card and can be topped up as per your KYC status.</p>',
  },
  {
    title: 'Q. How to complete my Min KYC?',
    description: '<p>You will be directed to the Yes Bank flow, provided you log in using the corporate registered mobile number. You will see the Popup to complete the ”Card account creation and KYC”. Click on “Card account creation” and enter the OTP received on the registered mobile number. Confirmation message for completing the card account creation will be displayed. Click on “KYC” and enter the details. Select the Document Type, Document Number, Name, Gender, DOB, Address and Pincode, Profession, Qualification, Annual Income, Source of Fund. Click on submit. MinKYC is completed successfully.</p>',
  },
  {
    title: 'Q. How to view the Yes Bank Card?',
    description: '<p>You can view the card, provided the min KYC is completed. Go to “Zaggle Cards” tab present on the bottom of the Zaggle mobile app, click on “Yes Bank multiwallet card”, card will be displayed along with the card balance and the transaction details. Please note that you need to create MPIN and complete the security questions while viewing the card, if not completed before.</p>',
  },
  {
    title: 'Q. Possible situation where card can be declined?',
    description: '<p>Network could be down; in which case you need to try again later. The card is yet to be activated. The amount being swiped is greater than the available balance on the card. In case of any such issues, please contact the Customer Care toll free number 1860 500 1231, between 10:00 AM to 7:00 PM, Monday to Saturday. You can also write an email to care@zaggle.in. The team will get the issue resolved at the earliest.</p>',
  },
  {
    title: 'Q. How to activate my Yes Bank Zinger card?',
    description: '<p>There is no separate process for activating the Yes Bank Zinger card. Cards get activated once the KYC is completed.</p>',
  },
  {
    title: 'Q. How to replace my Card in case I have lost the old card or the card has expired?',
    description: "<p>Incase the card get's lost, permanently block your card or the card has expired, go to \"Zaggle Cards,\" select your card, and choose \"Card Settings,\" then \"Block Card.\" Email care@zaggle.in with your Kit No. and dispatch address; a replacement card will be sent, with applicable charges deducted.</p>",
  },
  {
    title: 'Q. How I can pay driver salary?',
    description: '<p>Once click on the Driver Salary feature under settings, User will land on Beneficiary Management: it shows Beneficiary details like Beneficiary Name, Acc No, IFSC code. Click on the Transfer Button and select the Pending Months then transfer the funds successfully to Beneficiary account.</p>',
  },
  {
    header: 'FAQs For Yes Bank Kuber Cards',
    title: 'Q. What is the Yes Bank Kuber Card ?',
    description: '<p>The  Yes Bank Kuber Card is a prepaid Card that can be used at any VISA merchant in India.This card will come preloaded with the amount gifted to you.</p>',
  },
  {
    title: 'Q. How is the Yes Bank Kuber Card used?',
    description: '<p>The Yes Bank Kuber Card, being a swipe card just like any other debit/credit card, can be used at the point of sale at the merchant store by simply swiping it. The Yes Bank Kuber Card can also be used online.</p>',
  },
  {
    title: 'Q. For how much amount can the Yes Bank Kuber Card be swiped for at the Merchant Store?',
    description: '<p>The Yes Bank Kuber Card can be used for any amount up to the amount loaded on the card. The card can be used only until the validity period.</p>',
  },
  {
    title: 'Q. How do I check when the card will expire?',
    description: '<p>The card expiry date is printed on the front of the card.</p>',
  },
  {
    title: 'Q. Can we use this card online?',
    description: '<p>The Yes Bank Kuber Card can be used for making online purchases.</p>',
  },
  {
    title: 'Q. How can I check the balance on my card?',
    description: '<p>To check your Kuber Gift Card balance, go to the home page of the Zaggle Mobile App, tap on "Zaggle Cards", select your card, and view the balance displayed.</p>',
  },
  {
    title: 'Q. How do I place an order online?',
    description: '<p>Once you have selected your item, in the payment section select the VISA debit card option and enter the card number, expiry date, and CVV number. Next, enter the Personal Identification Number (PIN) & OTP for the second-factor authentication.</p>',
  },
  {
    title: 'Q. What happens if the card gets lost?',
    description: '<p>Kindly call the toll-free number 1860 500 1231 and place a request to block and reissue the card. The toll-free number is available from 10:00 AM to 7:00 PM, Monday to Saturday. You can also write an email to care@zaggle.in requesting for blocking the card.</p>',
  },
  {
    title: 'Q. What is the fee for re-issuing card?',
    description: '<p>The fees for reissuance is Rs. 100/- plus GST applicable.</p>',
  },
  {
    title: 'Q. Can value be added to the Yes Bank Kuber Card?',
    description: '<p>No. Once the amount on the Card has been used, the Card is no longer valid. You should cut any used Card in half and discard it.</p>',
  },
  {
    title: 'Q. Can the Card be used if its Available Balance does not cover the total purchase price?',
    description: '<p>The Card cannot be used to make transactions that exceed the available balance. For such a transaction, you need to pay the difference by another method if the merchant agrees.</p>',
  },
  {
    title: 'Q. Possible situation where card can be declined.',
    description: '<p>Network could be down, in which case you need to try again later. The card is yet to be activated. The amount being swiped is greater than the available balance on the card. The card is being used at wallets like PAYTM, MOBIKWIK etc. As per RBI guidelines, these cards cannot be used on wallets. In case of any such issues, please contact the Customer Care toll-free number 1860 500 1231, between 10:00 AM to 7:00 PM, Monday to Saturday. You can also write an email to care@zaggle.in. The team will get the issue resolved at the earliest.</p>',
  },
  {
    title: 'Q. How to activate/Add Kuber Gift Card?',
    description: '<p>To activate or link your Zaggle Card, navigate to "Zaggle Cards" in the app, select "Activate/Link your Zaggle Card", and follow the prompts to enter your card number and OTP. Your card will be successfully added or linked to your account.</p>',
  },
  {
    title: 'Q. How to update contact details for Yes Bank Kuber Card?',
    description: '<p>To update contact details for Yes Bank Kuber Card, please add the card on your mobile app.</p>',
  },
  {
    header: 'FAQs For Prepaid Cards',
    title: 'Q. What is the Yes Bank Kuber Card ?',
    description: '<p>The  Yes Bank Kuber Card is a prepaid Card that can be used at any VISA merchant in India.This card will come preloaded with the amount gifted to you.</p>',
  },
  {
    title: 'Q. How to withdraw money from zaggle card?',
    description: '<p>Cash withdrawals from the expense wallet are available at any ATM, subject to sufficient funds. Each transaction, including balance enquiries and statement requests, incurs a charge of Rs. 30 + 18% GST.</p>',
  },
  {
    title: 'Q. How to do UPI payment from app?',
    description: '<p>Currently, UPI payment options are not available. We are actively working to enhance our services and hope to offer this feature soon. Thank you for your trust in Zaggle!</p>',
  },
  {
    title: 'Q. Where I can use zaggle meal card?',
    description: '<p>The Zaggle meal card is accepted at over 7 million VISA/RuPay food outlets, including online and offline stores, restaurants, and food courts. Examples include Bigbasket, D-Mart, supermarkets, Swiggy, and Zomato.</p>',
  },
  {
    title: 'Q. Where zaggle Card can be used?',
    description: '<p>The Zaggle card is a prepaid card, preloaded with funds, that can be used at any VISA merchant across India. Enjoy seamless transactions with the convenience of a preloaded balance.</p>',
  },
  {
    title: 'Q. How to check status of the KYC?',
    description: '<p>To check your KYC status, go to "Zaggle Cards" in the Zaggle Mobile App, select your card, and view the KYC status beneath the card details. This status will be updated via bank API integration soon.</p>',
  },
  {
    title: 'Q. How to view card details on the app?',
    description: '<p>To view your Zaggle Card, go to "Zaggle Cards" in the Zaggle Mobile App, select your card, and enter your MPIN for authentication. Your card details will then become visible.</p>',
  },
  {
    title: 'Q. How to update mobile number?',
    description: '<p>To update your mobile number, please send the details to care@zaggle.in. Our team will process your request promptly.</p>',
  },
  {
    title: 'Q. How to add new card?',
    description: '<p>Please select your card type:<br/>1. IndusInd Kuber Gift Card<br/>2. IndusInd Zinger Multiwallet<br/>3. Yes Bank Zinger Multiwallet<br/><br/>If you select the first option: To activate or link your Zaggle Card, go to the Zaggle Mobile App home page, tap on "Zaggle Cards," select "Activate/Link your Zaggle Card," enter your card number, proceed with the OTP, and confirm.<br/><br/>If you select the second option: You need to activate your card by completing the Min KYC and Card Activation process via the Zaggle Mobile App. Follow the prompts to enter your details, consent, and verify with OTP.<br/><br/>If you select the third option: Complete the Yes Bank Account Registration and Min KYC process through the Zaggle Mobile App. Provide necessary details, consent to using your Aadhaar number, and submit to add your card.</p>',
  },
  {
    title: 'Q. How to set Mpin?',
    description: '<p>To create/set an MPIN, go to "Zaggle Cards" in the Zaggle Mobile App, tap the settings icon, select "Create MPIN," enter your desired MPIN and answer security questions, then click "Submit." Your MPIN will be successfully created.</p>',
  },
  {
    title: 'Q. How can I change IPIN PIN?',
    description: "<p>To change your IPIN, go to \"Zaggle Cards\" in the Zaggle Mobile App, select your card, tap the settings icon, choose 'Set IPIN,' enter the new IPIN and OTP, and click 'Confirm.' Your IPIN will be successfully updated.</p>",
  },
  {
    title: 'Q. What is the minimum & maximum limit for all wallets as per RBI guidelines?',
    description: '<p>Maximum limit with Min KYC is 10000 and Maximum limit with Full KYC is 200000.</p>',
  },
  {
    title: 'Q. How to check the summary of the transactions?',
    description: '<p>To download the transaction report, follow these steps:<br/>1. Log in to the Zaggle mobile app.<br/>2. Go to the Zaggle Cards section.<br/>3. Select the Zaggle Prepaid Card.<br/>4. Click the Download button on the card details page.<br/>5. Select the time period (note: periods longer than 90 days are not allowed) and choose one of these options: Send over Email or Download.<br/>- If you select Send over Email, the statement PDF will be sent to your registered email ID.<br/>- If you select Download, the statement PDF will be downloaded to your device.<br/>6. The statement is secured by a unique password, which is a combination of the first four characters of your first name followed by the last four digits of your mobile number. Make sure not to include any special characters. For example, if your first name is Rohit and your last name is Kumar and your mobile number is 1234562376, your password will be</p>',
  },
  {
    title: 'Q. How to select categories of the card?',
    description: '<p>The categories and the limits are provided by HR. So Kindly check with your HR.</p>',
  },
  {
    title: 'Q. What is the validity of credit loaded in cards?',
    description: '<p>The amount loaded in the card is valid till the card expires.</p>',
  },
  {
    title: 'Q. What to do if received as Invalid OTP?',
    description: "<p>Please verify that the number you're using to log in is correct. For further assistance, contact your HR department.</p>",
  },
  {
    title: 'Q. What to do in case of fraud transaction from my card?',
    description: '<p>Connect with customer support team at care@zaggle.in or give a call on the customer care number regarding the same.</p>',
  },
  {
    title: 'Q. How can I change POS PIN?',
    description: '<p>To change go to Zaggle card settings. Go to set IPIN / POS PIN, enter the details and the pin is set/changed.</p>',
  },
  {
    title: 'Q. How can I lock my card?',
    description: '<p>To temporarily lock your Zaggle Card, access "Zaggle Cards" in the app, select your card, tap settings, choose "Lock Card," provide reason and OTP, then confirm. Your card will be successfully locked.</p>',
  },
  {
    title: 'Q. How do I check when the card will expire?',
    description: '<p>The card expiry date is visible on the front of the card or accessible via the Zaggle Mobile App. Simply navigate to "Zaggle Cards," select your card, authenticate with your MPIN, and view the expiry date.</p>',
  },
  {
    title: 'Q. How does the taxation work for the remaining balance during the financial year end?',
    description: '<p>Please connect with your HR.</p>',
  },
  {
    title: 'Q. How much time does it take to activate the card?',
    description: '<p>How much time does it take to activate the card?</p>',
  },
  {
    title: 'Q. How to block the card?',
    description: "<p>To permanently block your card, follow these simple steps:<br/>1. Go to the home page of the Zaggle Mobile App.<br/>2. Tap on \"Zaggle Cards\" at the bottom of the page.<br/>3. Select your Zaggle Card.<br/>4. Tap on the settings icon located at the top right corner.<br/>5. Choose the 'Block Card' option.<br/>6. Enter the reason for blocking your card.<br/>7. Provide the OTP.<br/>8. Click on 'Confirm'.<br/>9. Voila Your card will be successfully blocked.</p>",
  },
  {
    title: 'Q. How to change MPIN?',
    description: '<p>To Change MPIN, follow these steps:<br/>1. Go to the home page of the Zaggle Mobile App<br/>2. Tap on "Zaggle Cards" at the bottom of the page<br/>3. Go to settings icon located at the top right corner.<br/>4. Select "Change MPIN."<br/>5. Enter your Old MPIN and the New MPIN.<br/>6. Click on "Submit."<br/>7. Your MPIN will be successfully updated.</p>',
  },
  {
    title: 'Q. How to check the status of approval of bills?',
    description: '<p>To check your bill submission status, go to "Zaggle Cards" and click on "Claims" to view the status of your previously submitted claims.</p>',
  },
  {
    title: 'Q. How to check full kyc appointment status?',
    description: '<p>Click on the Zaggle Card, then select the "Full KYC" button on the left side below the card to view your full KYC details.</p>',
  },
  {
    title: 'Q. How to close Zaggle account?',
    description: '<p>Connect with your HR.</p>',
  },
  {
    title: 'Q. What is virtual Zaggle card? How to use it?',
    description: '<p>A virtual Zaggle card is a digital version of a prepaid card provided by Zaggle. It offers the same functionality as a physical card but exists only in digital form which can be used for online purchases, subscriptions, and other digital transactions without needing a physical card. With a digital card provided you can use the same for online transaction using (card number, expiration date, and CVV) on an Indian e-commerce website in Indian rupees.</p>',
  },
  {
    title: 'Q. I have lost my Zinger (Zaggle) Card. How can I prevent it from misuse?',
    description: '<p>You can secure your Zinger Card by temporarily locking your card under Card Settings.</p>',
  },
  {
    title: 'Q. What is the limit for POS transaction?',
    description: '<p>The limit for POS transactions is as follows:<br/>For a Min KYC user, the POS transaction limit is ₹10,000 per day.<br/>For a Full KYC user, the POS transaction limit is ₹2,00,000 per day.<br/>Users can set their desired limits for channels through the mobile or web application, up to the standard limits mentioned above. To set limits, follow these steps:<br/>1. Go to Zaggle card settings<br/>2. Then select "Manage Card Usage"<br/>3. Next, choose the POS Transaction Channel<br/>4. Click on the toggle button to enable it and set the appropriate limits<br/>5. Finally, click the "Update" button<br/>6. Your POS transaction channel limit will be set successfully.</p>',
  },
  {
    title: 'Q. How to check card dispatch status?',
    description: '<p>Check with you HR for the dispatch status.</p>',
  },
  {
    title: 'Q. Do Zaggle have RBI License?',
    description: "<p>While Zaggle doesn't have an RBI license, we are integrated with over 100 banks that hold the necessary licenses. This ensures secure and compliant financial transactions for our users.</p>",
  },
  {
    title: 'Q. How to reset forgot MPIN?',
    description: "<p>If you've forgotten your MPIN, go to \"Zaggle Cards\" in the Zaggle Mobile App, tap the settings icon, select \"Forgot MPIN,\" answer the security question, and click \"Submit.\" If you don't recall the answers, click \"Send MPIN by Email\" to receive it via your registered email address.</p>",
  },
  {
    title: 'Q. How to change the limit of the card?',
    description: '<p>To change the wallet limit, go to Card Settings</p>',
  },


];



// WEBPACK FOOTER //
// client/containers/FaQs/constants.js